import { MainItem, Field, Alert } from '../../common/services/main/main.model';
import { SettingService } from '../../common/services/setting/setting.service';


export class Broker extends MainItem {

    values: {
        $key: string,
        ref: number,
        created: firebase.firestore.FieldValue,
        createdBy: string,
        updated: firebase.firestore.FieldValue,
        updatedBy: string,
        alerts: Alert[],
        synaps: any,

        status: string,
        type: string,
        fee: number,
        allAgencies: boolean,
        agencies: string[],
        dateStart: Date,
        dateEnd: Date,
    }

    constructor(
        values: any = null,
        public setting?: SettingService,
    ) {
        super(
            'brokers',
            {
                status: new Field({ label: 'Status', input: 'select', inputOptions: { param: 'brokerStatus' }, default:'pending' }),
                // type: new Field({ label: 'Type', input: 'select', inputOptions: { param: 'brokerTypes' } }),
                fee: new Field({ label: 'Broker Fee (%)', input: 'number' }),
                allAgencies: new Field({ label: 'All Agencies', defaut: true, input: 'boolean' }),
                agencies: new Field({
                    label: 'For which Agencies?',
                    input: 'select', inputOptions: { param: 'agencies', multi: true },
                    show: (values) => { return !values.allAgencies; },
                    validations: {required:true}
                }),
                dateStart: new Field({ label: 'Start Date', input: 'date' }),
                dateEnd: new Field({ label: 'End Date', input: 'date' }),
            },
            // Forms
            {
                main: {
                    title: null,
                    fields: [`status`, `fee`, `dateStart`, `dateEnd`]
                },
                newBroker: {
                    title: null,
                    fields: ['allAgencies', 'agencies']
                },
            },
            // Tables
            {
                main: {
                    title: 'Broker List',
                    columns: [
                        { field: 'icon', type: 'icon', label: '' },
                        { field: 'ref', type: 'string', label: 'Ref', options: { prefix: 'B' } },
                        { field: 'displayname', type: 'string', label: 'Name' },
                        { field: 'typeDisplay', type: 'string', label: 'Type' },
                        { field: 'fee', type: 'number', label: 'Fee (%)' },
                        { field: 'dateStart', type: 'date', label: 'Start Date' },
                        { field: 'dateEnd', type: 'date', label: 'End Date' },
                    ],
                },
            },
            // Config File
            {
                path: 'brokers/', filename: (data) => {
                    let filename = 'broker-';
                    filename += 'I' + data.ref;
                    return filename
                }
            },
            setting,
        );
        if (values) {
            this.fromFB(values);
        }

    }



}